import React, { useState, createContext, ReactNode, useEffect } from 'react'
import { useTradeSocket } from '../app/hooks/trade/tradeSocket'
import { TRADE_SOCKET_URL } from '../app/constants/APIKEYS'
import axios from 'axios'
import { useTradePosition } from '../app/hooks/trade/tradePosition'

type SocketContextType = {
	socket: any
}
type SocketProviderProps = {
	children: ReactNode
}
export const SocketContext = createContext<SocketContextType>(
	{} as SocketContextType
)
const SocketProvider = ({ children }: SocketProviderProps) => {
	const socket = useTradeSocket(TRADE_SOCKET_URL)
	return (
		<SocketContext.Provider
			value={{
				socket,
			}}>
			{children}
		</SocketContext.Provider>
	)
}

export default SocketProvider
